import React, { Component, Fragment } from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./containers/Navbar";
import Header from "./containers/Header";
import Footer from "./containers/Footer";
import Content from "./presentational/Content";
import Routes from "./routes";

class App extends Component {
    render() {
        return (
            <Router>
                <Fragment>
                    <Navbar />
                    <Header />
                    <Content>
                        <Routes />
                    </Content>
                    <Footer />
                </Fragment>
            </Router>
        );
    }
}

export default App;
